var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.11 16.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.71,6.15H10.65V4.09a4.1,4.1,0,0,0-8.19,0V6.15H.4a.4.4,0,0,0-.4.4V16.4a.4.4,0,0,0,.4.4H12.71a.4.4,0,0,0,.4-.4V6.55A.4.4,0,0,0,12.71,6.15ZM3.26,4.09a3.3,3.3,0,0,1,6.59,0V6.15H3.26ZM12.31,16H.8V7H12.31ZM7,11.37a.43.43,0,0,1,0,.11v2.46a.4.4,0,0,1-.8,0V11.48a.43.43,0,0,1,0-.11.81.81,0,0,1-.45-.72.83.83,0,1,1,1.66,0A.81.81,0,0,1,7,11.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.353c4ede4666d49ef664cc1e40797316.svg";
export { ForwardRef as ReactComponent };